import { NavElements } from "type/navigation/main_navigation.type";

export const ADM_NAV_ELEMENTS: NavElements = {
  GROUPS: {
    title: "ODREDNICE",
    path: "/admin-dashboard/dl-group-li",
    adminAccess: true,
  },
  DL_UNITS: { title: "JEDINICE", path: "/admin-dashboard/dl-unit-li" },
  PHOTO_SERIES: { title: "FOTO SERIJE", path: "/admin-dashboard/photo-ser-li" },
  USERS: {
    title: "KORISNICI",
    path: "/admin-dashboard/user-li",
    adminAccess: true,
  },
  HEMEROTEKA: { title: "HEMEROTEKA", path: "/hemeroteka" },
  L_OUT: { title: "izloguj se", path: "/" },
};
